import { connect } from 'react-redux';
import LoginPage from './component';
import { clearFetchingStatus, login, loginViaCode } from './actions';

const mapStateToProps = (state) => ({
  ...state.login,
  config: state.appConfig.config,
});

const mapDispatchToProps = (dispatch) => ({
  login: (creds) => dispatch(login(creds)),
  loginViaCode: (code) => dispatch(loginViaCode(code)),
  clearFetchingStatus: () => {
    dispatch(clearFetchingStatus());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);
